import {
    EonUiDropdown,
    EonUiDropdownOption,
} from "@eon-ui/eon-ui-components-react";
import { useMemo } from "react";
import {
    getCompanyCanonicalId,
    getCompanyNameFromId,
} from "../OnboardingPortal.utils";

const OnboardingPortalCompanyFilter = ({
    t,
    company,
    setCompany,
    list,
}: {
    t: (key: string) => string;
    company: string;
    setCompany: (company: string) => void;
    list: { company?: string }[];
}) => {
    const companyOptions = useMemo(() => {
        // Companies may be stored as an ID or (for legacy data) a plain
        // name - canonicalize to ID first so both cases are treated as the
        // same company (no duplicate options) while counting.
        const counts = new Map<string, number>();
        list.forEach((item) => {
            const canonicalId = getCompanyCanonicalId(item.company);
            if (!canonicalId) {
                return;
            }
            counts.set(canonicalId, (counts.get(canonicalId) || 0) + 1);
        });

        return Array.from(counts.entries())
            .map(([id, count]) => ({
                id,
                name: getCompanyNameFromId(id),
                count,
            }))
            .sort((a, b) =>
                a.name.localeCompare(b.name, undefined, {
                    sensitivity: "base",
                })
            );
    }, [list]);

    return (
        <EonUiDropdown
            label={t("onboardingPortal.tableHeaders.company")}
            size="small"
            value={company}
            onValueChanged={(e) => setCompany(e.target.value)}
            height={"300px"}
            key={company}
            style={{ minWidth: "200px", width: "auto", maxWidth: "100%" }}
        >
            <EonUiDropdownOption
                key={""}
                value={""}
                label={t(`onboardingPortal.tableHeaders.selectAll`)}
            />
            {companyOptions.map(({ id, name, count }) => (
                <EonUiDropdownOption
                    key={id}
                    value={id}
                    label={`${name} (${count})`}
                />
            ))}
        </EonUiDropdown>
    );
};

export default OnboardingPortalCompanyFilter;
